// Shop JavaScript

document.addEventListener('DOMContentLoaded', function() {
  console.log('Shopify tema yüklendi');

  // Variant seçim kontrolü
  const variantSelect = document.getElementById('variant');
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      console.log('Seçilen variant:', this.value);
    });
  }

  // Form gönderi kontrolü
  const cartForm = document.querySelector('form[action*="cart/add"]');
  if (cartForm) {
    cartForm.addEventListener('submit', function(e) {
      const quantity = this.querySelector('input[name="quantity"]').value;
      console.log('Sepete eklenen miktar:', quantity);
    });
  }
});

// Utility function: Para formatı
function formatPrice(price) {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY'
  }).format(price / 100);
}
